<div class="mt-4">
  @if (listTitleKey()) {
    <h2 [translate]="listTitleKey()" class="mb-3"></h2>
  }
  @if (listHeaderKey()) {
    <p class="text--big mb-4" [innerHTML]="listHeaderKey() | translate | safeHtml"></p>
  }
  <div class="row gy-4">
    @for (product of productList(); track $index) {
      <div class="col-12 col-lg-6">
        <mwe-wizard-product-card-container
          [product]="product"
          [isAvailableAtNewAddress]="isAvailableAtNewAddress()"
          [isDisabled]="!isAvailableAtNewAddress()"
          [showTariffClasses]="true"
          [isRelocationProcess]="isRelocationProcess()"
        />
      </div>
    }
  </div>
</div>
